import React from 'react';
import universal from 'react-universal-component';
import EmotionWrapper from './emotion-wrapper';

const UniversalComponent = universal(
  ({ page }) =>
    import(`Pages/${page}` /* webpackExclude: /.(style|test)+.js$/ */),
  {
    ignoreBabelRename: true,
  },
);

export default function App(props) {
  return (
    <EmotionWrapper>
      <UniversalComponent {...props} />
    </EmotionWrapper>
  );
}
